export const VALUES_FONT_SIZES = [10, 11, 12, 13, 14, 15, 16];

export const TOTAL_LABEL_FONT_SIZES = [10, 12, 14, 16, 18, 20, 22];

export const TOTAL_VALUE_FONT_SIZES = [16, 18, 20, 22, 24, 26, 28];
